import { Share2 } from "lucide-react";
import { toast } from "sonner";

// Solo il link pubblico alla Home: mai URL della scheda o dati dell'utente
export const PUBLIC_URL = "https://medicodellepiante.luigiadevanna.it/";
const SHARE_TEXT = "Prova Medico delle Piante: un aiuto per capire cosa sta succedendo alla tua pianta.";

const copyLink = async () => {
  const value = `${SHARE_TEXT} ${PUBLIC_URL}`;
  try {
    await navigator.clipboard.writeText(value);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
  toast.success("Link copiato");
};

export const share = async () => {
  const data = { title: "Medico delle Piante", text: SHARE_TEXT, url: PUBLIC_URL };
  if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
    try {
      await navigator.share(data);
    } catch (e) {
      if (e?.name !== "AbortError") await copyLink();
    }
    return;
  }
  await copyLink();
};

export default function ShareButton({ className = "", testid = "share-app-button" }) {
  return (
    <button type="button" onClick={share} className={`inline-flex items-center justify-center gap-2 rounded-full border border-[#c9a96e] px-5 py-2.5 text-xs font-semibold tracking-[0.08em] text-[#0d2517] transition-colors hover:bg-[#c9a96e]/15 ${className}`} data-testid={testid}>
      <Share2 size={14} className="text-[#b8975a]" /> Condividi Medico delle Piante
    </button>
  );
}
